<template>
  <div>
    <Header v-on:setsearchdateshow="getTableDataByAPI" v-on:changeshowmse="changeshowmse"></Header>


    <section :class="{ fullscreen: isfullscreen }" style="margin: 230px auto 0;">

      <div style="display:none;">Checked names: {{ checkedNames }}</div>

      <div class="index_table">
        <table>
          <thead>
            <tr>
              <th width="55">LDDB ID</th>
              <!-- <th width="55">Tag</th> -->
              <th width="55">中文名</th>
              <th width="55">英文名</th>
              <th width="55">CAS号</th>
              <!-- <th width="55">化合物<br />(母核SMILES)</th> -->
              <th width="55" style="min-width:250px">分子骨架</th>
              <!-- <th width="55">探针改造标签<br />(SMILES)</th> -->
              <th width="55" style="min-width:250px">探针改造标签</th>
              <th width="55">探针类型</th>
              <!-- <th width="55">分子量<br />（MW &lt 500 g/mol）</th>
              <th width="55">氢键给体数<br />（HBA &lt 10）</th>
              <th width="55">氢建受体数<br />（HBD &lt 5）</th>
              <th width="55">脂水分配系数<br />（Log P &lt 5）</th>
              <th width="55">可旋转键个数<br />（Rot B &lt 10）</th>
              <th width="100">极表面积<br />（PSA&lt140Å）</th>-->
              <th width="55" style="min-width:220px">分子活性描述</th>
              <th width="55">潜在靶点*</th>
              <th width="55">Binding DB靶点**</th>
              <th width="55" style="min-width:220px">Binding DB靶点对应文章及DOI</th>
              <!-- <th width="55">文章DOI</th> -->
              <!-- <th width="55">备注</th> -->
            </tr>
          </thead>
          <tbody>

            <tr v-for=" (v, key) in list" :key="key" :style="setstyle(key)">
              <td>{{ v['lddbid'] }}</td>
              <!-- <td>{{ v['tag'] }}</td> -->
              <td>{{ v['name'] }}</td>
              <td>{{ v['ipiac'] }}</td>
              <td>{{ v['cas'] }}</td>
              <!-- <td style="min-width: 200px;">

                <div v-html="sethtml(v['smiles'])" @click="showall($event)" style=""></div>
              </td> -->
              <td><img :src="v['structural'] && v['structural']['val'] != null ? v['structural']['val']['url'] : ''"
                  class="setimg" alt="化合物结构图" /></td>
              <!-- <td>{{ v['smiles_tz'] }}</td> -->
              <td><img
                  :src="v['structural_tz'] && v['structural_tz']['val'] != null ? v['structural_tz']['val']['url'] : ''"
                  class="setimg">
              </td>
              <td>{{ v['probe_type'] }}</td>
              <!-- <td>{{ v['molecular_weight'] }}</td>
              <td>{{ v['num_g'] }}</td>
              <td>{{ v['num_s'] }}</td>
              <td>{{ v['logp'] }}</td>
              <td>{{ v['rotb'] }}</td>
              <td>{{ v['psa'] }}</td>-->
              <td>
                <div v-html="sethtml(v['description'])" @click="showall($event)" style=""></div>
              </td>
              <td>
                <div v-html="sethtml(v['target'])" @click="showall($event)" style=""></div>
                <button @click="getinfo(v['lddbid'])" style="font-size:12px">提供靶点线索</button>
              </td>
              <td>
                <div v-html="sethtml(v['celllines'])" @click="showall($event)" style=""></div>
              </td>
              <td>
                <div v-html="sethtml(v['reported_probes'])" @click="showall($event)" style=""></div>
                <br />
                {{ v['doi'] }}
              </td>
              <!-- <td>{{ v['doi'] }}</td> -->
              <!-- <td>{{ v['remark'] }}</td> -->
            </tr>

          </tbody>
        </table>
        <div v-if="!list.length && isload" class="no-font">
          {{nonany}}
        </div>
        <div class="pagediv">
          <ul class="pagination">
            <li :class="page.pageNum <= 1 ? 'disabled' : ''" class="page-item" @click="prePage()"><a href="#">&laquo;</a>
            </li>
            <li :class="page.pageNum === index ? 'page-link active' : ''" v-for="index in pageTotal"
              @click="curPage(index)"
              v-show="(index < 6 || pageTotal == index || (index >= page.pageNum && index <= page.pageNum + 4))">
              <a href="#" v-if="(index == page.pageNum && index > 5)"
                style=" color: #337ab7;background-color: #fff;border: 1px solid #ddd;"
                @dblclick="curPage(page.pageNum - 1)">...</a>
              <a href="#">{{ index }}</a>
              <a href="#" v-if="index == (page.pageNum + 4) && pageTotal != index"
                @click="curPage(page.pageNum + 1)">...</a>
            </li>
            <li :class="page.pageNum >= pageTotal ? 'disabled' : ''" class="page-item" @click="nextPage()"><a
                href="#">&raquo;</a></li>
            <li>
              <span>前往</span><input type="text" class="page_input" v-model="inputpage" @change="setpage()"><span>页</span>
            </li>
          </ul>

        </div>
      </div>
    </section>
    <div class="pop_bg" v-show="popBgShow" @click="closeAll()"></div>
    <div class="pop_apply_box" v-show="iptPopShow">
      <div class="header_info">
        <div class="title">提供靶点线索</div>
        <a href="javascript:void(0)" class="close_btn" @click="closeAll()">×</a>
      </div>
      <form :model="modifyForm" :rules="modifyrules">
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">姓名：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="输入姓名" name="name" v-model="modifyForm.name">
          </dd>
          <span style="color:red" class="required">*</span>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">电话：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="输入电话" name="doinumber" v-model="modifyForm.doinumber">
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">邮箱：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="输入邮箱" name="email"
              v-model="modifyForm.email">
          </dd>
          <span style="color:red" class="required">*</span>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">单位：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="输入单位" name="company"
              v-model="modifyForm.company">
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">职位：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="输入职位" name="position"
              v-model="modifyForm.position">
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">内容：</dt>
          <dd class="formcolumn-item-ct">
            <textarea type="text" placeholder="输入内容" name="remark"
              v-model="modifyForm.remark"></textarea>
          </dd>
          <span style="color:red" class="required">*</span>
        </dl>
        <!-- <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">验证码：</dt>
          <dd class="formcolumn-item-ct">
            <div id="GBCAPTCHAIMG" class="form-vcodebox"><img :src='upyzm()'></div>
            <input type="text" size="4" maxlength="4" title="验证码" placeholder="验证码" class="formcom-vcode" exrequired="true" id="GBCAPTHCA">
            <span style="color:red" class="required">*</span>
            <div id="reguser_verifycode-tips" class="formcolumn-item-tips">
                        <span class="formcolumn-item-tipstxt">请填写图片中的字符</span>
                    </div>
          </dd>
        </dl> -->
        
        <div class="footer_btn">
            <input type="button" id="GBPOST" class="tj" value="提交" @click="addconfirm()" style="width:40%">
        </div>
      </form>
    </div>


    <Footer></Footer>
  </div>
</template>

<script>
import Header from './header/IndexShow.vue'
import Footer from './footer/Index.vue'
import api from './../axios/api.js'
import AppLink from './../components/AppLink.vue'
export default {
  components: {
    Header,
    Footer,
    AppLink
  },
  data() {
    return {
      nonany:"无化合物数据",
      messagetext: "",
      messageinfo: false,
      tableData: [],
      checkedNames: [],
      isShow: false,
      isfullscreen: false,
      popBgShow: false,
      popShow: false,
      popSourcesShow: false,
      selectData: {

      },
      list: [],
      showpareArr: [],
      showname: [],
      syData: {},
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      total: 0, // 当前条数
      param: {},
      rowselect: {
      },
      allchecked: null,
      listA: [],
      downloadtype: 1,
      isarticle: false,
      inputpage: "",
      openkey: [],
      isfullcheck: "",
      showtitle: "",
      setwidths: [],
      seloption: [],
      isload: false,
      iptPopShow:false,
      modifyForm: {
        name: "",
        doinumber: "",
        email: "",
        company:"",
        position:"",
        remark:"",
        type:2
      },
      modifyrules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        remark: [{ required: true, message: "请输入内容", trigger: "blur" }],
      }
    }
  },
  created() {
    this.getTableDataByAPI();
  },

  methods: {
    changeshowmse(text){
      this.nonany=text;
    },
    getinfo(lddbid){
      let that=this;
      that.modifyForm.lddbid=lddbid;
      that.iptPopShow=true;
      that.popBgShow=true;
    },
    upyzm(){
      var sj=Math.floor(Math.random() * (9 - 1 + 1)) + 1;
      return "https://www.leadartech.cn/index.aspx?a=verifycode&verifytype=guestbook&rnd="+sj;
    },
    addconfirm(){
      let that=this;
      if (!that.modifyForm.remark) {
        that.showErrorInfo("内容不能为空！");
      }else if (!that.modifyForm.name) {
        that.showErrorInfo("姓名不能为空！");
      }else if (!that.modifyForm.email) {
        that.showErrorInfo("邮箱不能为空！");
      } else {
        let urllist = '/action/ermqadqwapurkqnvn/adfeedback';
        console.log(urllist);
        api.getTableData(urllist, JSON.stringify(that.modifyForm)).then(res => {
          console.log(res);
          if (res.result == 1) {
            that.showInfo('提交成功');
            that.iptPopShow=false;
            that.popBgShow=false;
          }
        });
      }
    },
    sethtml(val) {
      var ithtml = val;
      if (ithtml && ithtml.length > 100) {
        var lite = ithtml.substring(0, 100);
        var itdiv = $("<div data-content='' data-lite=''></div>");
        itdiv.attr("data-content", ithtml);
        itdiv.attr("data-lite", lite);
        itdiv.html(lite);
        ithtml = itdiv[0].outerHTML;
        ithtml += '<span class="more_text">[...]</span>';
      }
      return ithtml;
    },
    showwd(SitesList) {
      if (SitesList && SitesList.length > 0) {
        var isshow = false;
        SitesList.forEach(function (val) {
          if (val) {
            isshow = true;
          }
        })
        return isshow;
      }
    },
    linkactive(LDDBid, Source, ProbeId) {
      if (Source[0].indexOf('LDRA') != -1) {
        this.$router.push({ path: '/site', query: { LDDBid: LDDBid, ProbeId: ProbeId } });
      } else {
        var isLogined = localStorage.getItem("isLogined");
        if (!isLogined) {
          this.showInfo('该功能仅限高级会员使用，请登录或联系我们');
          return
        }
        this.$router.push({ path: '/site', query: { LDDBid: LDDBid, ProbeId: ProbeId } });
      }
    },
    useryz(LDDBid, ProbeId) {
      this.$router.push({ path: '/click' })
    },
    handleClick() {
      var that = this;
      var selectedop = JSON.parse(JSON.stringify(that.checkedNames));
      that.checkedNames = [];
      that.setwidths = [];
      that.seloption.forEach(function (v) {
        if (!selectedop || !selectedop.length) {
          if (v.IsDefault == 1) {
            that.checkedNames.push(v.Field);
            that.setwidths.push(v.setwidth);
          }
        } else {
          if (selectedop.indexOf(v.Field) != -1) {
            that.checkedNames.push(v.Field);
            that.setwidths.push(v.setwidth);
          }
        }
      });
    },
    showall(e) {
      var morestyle = e.currentTarget.getElementsByClassName("more_text");
      if (morestyle.length > 0 && (morestyle[0].style.cssText == "display: none;")) {
        var getlite = e.currentTarget.firstElementChild.dataset.lite;
        $(e.currentTarget.firstElementChild).html(getlite);
        morestyle[0].style = "display:block;";
      } else {
        if (morestyle.length > 0 && (morestyle[0].style.cssText == "display: block;" || !morestyle[0].style.length)) {
          var gettext = e.currentTarget.firstElementChild.dataset.content;
          $(e.currentTarget.firstElementChild).html(gettext);
          morestyle[0].style = "display:none";
        }
      }
    },
    enter(val) {
      var that = this;
      if (val.indexOf('LDRA') != -1) {
        var postdata = {
          "datacode": val
        };
        var urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
          if (res.data && res.data.rows.length > 0) {
            that.syData = res.data.rows[0];
            that.showtitle = that.syData.essaydoi;
          }
        });
      }
      that.showtitle = "";
    },
    clickfullcheck() {
      if (!this.isfullcheck) {
        this.checkedNames = [];
        return;
      }

      for (let v in this.selectData) {
        let kindex = this.checkedNames.indexOf(v);
        if (kindex == -1) {
          this.checkedNames.push(v);
        }
      }
    },
    setstyle(val) {
      if (val % 2 == 0) {
        return "background: #fff;";
      }
      return "background: #f4f7fb;";
    },
    checkall() {
      var that = this;
      if (that.allchecked == true) {
        that.rowselect = [];//清空数据
      } else {
        that.list.forEach(function (v) {
          that.$set(that.rowselect, v['LDDBid'], true);
        });
      }
    },
    setpage() {
      if (this.inputpage) {
        this.page.pageNum = parseInt(this.inputpage);
        this.getPatients(this.page.pageNum);
        this.inputpage = "";
      }
    },
    curPage(index) {
      this.getPatients(index);
    },
    prePage() {
      if (this.page.pageNum > 1) {
        this.getPatients(--this.page.pageNum);
      }
    },
    nextPage() {
      if (this.page.pageNum < this.pageTotal) {
        this.getPatients(++this.page.pageNum);
      }
    },
    getPatients(pageNum) {
      this.allchecked = null;
      this.rowselect = {};
      this.page.pageNum = pageNum;
      this.getTableDataByAPI();
    },
    morechart(val, ind, e) {
      var index = this.showpareArr.indexOf(val);
      if (index != -1) {
        if (index > -1) {
          this.showname[ind] = "展开";
          this.showpareArr.splice(index, 1);
          this.openkey.splice(index, 1);
        }
      } else {
        this.showpareArr.push(val);
        this.openkey.push(ind);
        this.showname[ind] = "收起";
      }
    },
    showpare(val) {
      if (val) {
        if (val.DisplayLevel == 1) {
          return true;
        }
        if (this.showpareArr.indexOf(val.LDDBid) != -1 && val.DisplayLevel == 2) {
          return true;
        }
        return false;
      }
    },
    resetVal(val) {
      let newval = "";
      if (val == undefined) {
        return newval;
      }
      val.forEach(function (item) {
        var nval = "";
        if (item) {
          if (item.indexOf('LDCLL') != -1) {
            item = item.replace('LDCLL', '');
          }
          if (item.indexOf('LDCLC') != -1) {
            item = item.replace('LDCLC', '');
          }
          if (item.indexOf('LDCL') != -1) {
            item = item.replace('LDCL', '');
          }
          nval = item;
        }
        newval += nval + "<br>";
      })
      return newval;
    },
    setrem(v, cv) {
      var otherop = ["ProteinId"];
      if (otherop.indexOf(cv) != -1) {
        var url = "https://www.uniprot.org/uniprotkb/" + v[otherop] + "/entry";
        return url;
      }
      return "";
    },
    setremAl(v, cv) {
      var otherop = ["ProteinId"];
      if (otherop.indexOf(cv) != -1) {
        var url = "https://alphafold.ebi.ac.uk/entry/" + v[otherop];
        return url;
      }
      return "";
    },
    setSourceValue(item, value) {
      var rethtml = '';
      if (value == 0) {
        //文献
        if (item.References != null && item.References.lenght != 0) {
          for (var i = 0; i < item.References.length; i++) {
            if (rethtml.length > 0) {
              rethtml += "<br/>";
            }
            var url = item.References[i]["Url"];
            if (url != null && url != '') {
              rethtml += '<a href="' + url + '" target="_blank">' + item.References[i].No + '</a>';
            } else {
              rethtml += item.References[i].No;
            }
          }
        }
      } else {
        //实验记录
        rethtml = item.RecordNo;
      }
      return rethtml;
    },
    selectDisplay() {
      if (this.isShow) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    saveDisplay() {
      var that = this;
      if (that.isShow) {
        that.isShow = false;
      } else {
        that.isShow = true;
      }
      localStorage.setItem('selectedoption', JSON.stringify(that.checkedNames));
    },
    fullscreen() {
      if (this.isfullscreen) {
        this.isfullscreen = false;
      } else {
        this.isfullscreen = true;
      }
    },
    selectdownload() {
      this.popBgShow = true;
      this.popShow = true;
    },
    applyClose() {
      this.popBgShow = false;
      this.popShow = false;
    },
    sourcesOpen(val) {
      this.getdsjyData(val);
      if (!this.isarticle) {
        this.popBgShow = true;
        this.popSourcesShow = true;
      }
    },
    sourcesClose() {
      this.popBgShow = false;
      this.popSourcesShow = false;
    },
    closeAll() {
      this.popBgShow = false;
      this.popSourcesShow = false;
      this.popShow = false;
      this.iptPopShow = false;
    },
    async getTableDataByAPI(param) {
      //查询列表信息
      let that = this;
      that.nonany="无化合物数据";
      var isLogined = localStorage.getItem("isLogined");
      if (param) {
        param = JSON.parse(param);
        that.param = param;
        param.page = that.page;
        param.page.pageNum = 1;
        param.sl=isLogined;
        param = JSON.stringify(param);
      } else {
        param = that.param;
        param.page = that.page;
        param.total = that.total;
        param.totalPages = that.pageTotal;
        param.sl=isLogined;
        param = JSON.stringify(param);
      }
      that.list = [];
      let urllist = '/action/ewfeahhhiobbuyfzm/showlist';
      await api.getTableData(urllist, param).then(res => {
        if (res.data) {
          if (that.page.pageNum == 1) {
            that.pageTotal = res.data.param.totalPages;
            that.total = res.data.param.total;
            that.param.total = that.total;
            that.param.totalPages = that.pageTotal;

          }
          var yssdata = res.data.rows;
          yssdata.forEach(function (v,) {
            let onelist = JSON.parse(JSON.stringify(v));
            that.list.push(onelist);
          });
          that.isload = true;
        }
      });
    },

    showInfo(val) {
      toastr.info(val, "提醒", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-top-center"
      });
      return;
    },
    showErrorInfo(val) {
      toastr.error(val, "错误", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-top-center"
      });
      return;
    }
  },

}
</script>

<style scoped>
.pagediv {
  position: fixed;
  left: 0;
  bottom: 88px;
  width: 100%;
  z-index: 10;
}

.footer_copyright {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 88px;
  z-index: -1;
  padding: 0 15px;
}

section .index_table {
  padding-bottom: 150px;
}

section .index_table table tbody tr td:first-child {
  min-width: auto;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

#complex_3d {
  width: 100%;
  height: 700px;
  position: relative;
}

.radio_download {
  width: auto;
  height: 17px;
  margin: 5px;
  line-height: 17px;
  vertical-align: middle;
}

.radio_div {
  font-size: 16px;
  text-align: center;
}

.radio_bottom {
  margin-bottom: 10px;
}

.page_input {
  position: relative;
  float: left;
  padding: 5px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  width: 40px;
}

.othermore {
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}


.show_text {
  -webkit-line-clamp: "unset"
}

.message_box {
  text-align: center;
  line-height: middle;
  line-height: 80px;
  font-size: 19px;
}

.no-font {
  text-align: center;
  line-height: 82px;
  color: white;
  font-size: 16px;
}

.formcolumn-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.formcolumn-item-ct {
  width: calc(100% - 100px);
  position: relative;
  display: flex;
  line-height: 38px;
}

.pop_apply_box form .formcolumn-item-ct textarea {
    width: 100%;
    height: 150px;
    padding: 5px 10px;
    border: 1px solid #dedede;
    border-radius: 3px;
    box-shadow: none;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    resize: none;
}

.pop_apply_box form .formcolumn-item-ct input {
    /* width: 90%; */
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    border: 1px solid #dedede;
    border-radius: 3px;
    box-shadow: none;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
}

.footer_btn {
    border-top: 0;
    text-align: center;
    display: flex;
    justify-content: center;
}

.pop_apply_box form .footer_btn input {
    background: var(--bgColor);
    color: #fff;
    width: 40%;
    padding: 0;
    font-size: 16px;
    height: 40px;
    transition: all 0.2s linear 0s;
}

.pop_apply_box form .formcolumn-item-ct .formcom-vcode {
    width: 20%;
}

.pop_apply_box form .formcolumn-item-ct .formcolumn-item-tips {
    order: 4;
}

.form-vcodebox {
  width: 110px;
    order: 1;
    height: 38px;
    margin-left: 10px;
}
.form-vcodebox img {
    height: 38px;
}

.required {
    order: 3;
    margin-left: 10px;
    font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/views/show.vue